import { SettingsIcon, FlagIcon, HelpCircleIcon, GridIcon } from '../icons'
import ZDashboardIcon from './assets/icons/z-dashboard.svg'
import ZChatIcon from './assets/icons/z-chat.svg'
import ZCheckboxIcon from './assets/icons/z-checkbox.svg'
import ZInboxIcon from './assets/icons/z-inbox.svg'
import ZCoachingIcon from './assets/icons/z-coaching.svg'

export default {
  dashboard: ZDashboardIcon,
  conversations: ZChatIcon,
  assignments: ZCheckboxIcon,
  activity: ZInboxIcon,
  coaching: ZCoachingIcon,
  settings: SettingsIcon,
  tasks: ZCheckboxIcon,
  users: FlagIcon,
  help: HelpCircleIcon,
  productTray: GridIcon,
}
